export const productImage =
  'https://cdn.magicpatterns.com/uploads/87jD6dZUk1y89aDv3JFyyA/ChatGPT-Image-11-ago-2026_-10_12_40-p.m..webp'

export const checkoutUrl = 'https://padel-master-pro.impultienda.ar/checkout'

export const pains = [
  {
    emoji: '😰',
    title: 'Ogni settimana ricominci tutto da capo',
    text: 'Preparare le lezioni. Cercare nuovi esercizi. Organizzare le progressioni. Adattare il lavoro ai diversi livelli. Preparare il lavoro tecnico e tattico. Monitorare i giocatori. Aggiornare il materiale. E prima ancora di entrare in campo... hai già trascorso ore a preparare tutto.',
  },
  {
    emoji: '🤔',
    title: 'Ogni giocatore richiede un lavoro diverso',
    text: 'Alcuni devono migliorare la tecnica. Altri devono sviluppare la tattica. Alcuni hanno difficoltà nella difesa. Altri devono perfezionare il gioco a rete. Ogni giocatore e ogni gruppo richiedono esercizi, progressioni e pianificazioni differenti. Creare tutto manualmente richiede moltissimo tempo.',
  },
  {
    emoji: '📚',
    title: 'Hai tantissimo materiale... ma niente è davvero organizzato',
    text: 'Libri. PDF. Video. Appunti. Cartelle. Negli anni hai accumulato moltissime risorse. Ma ogni volta devi cercare, confrontare, modificare e ricostruire tutto. Ti manca un unico sistema professionale già pronto.',
  },
  {
    emoji: '😩',
    title: 'Passi più tempo a preparare le lezioni che ad allenare',
    text: 'Tra pianificazioni... esercizi... progressioni... programmi... valutazioni... documentazione... dedichi sempre più tempo alla preparazione invece di concentrarti sul campo e sui tuoi giocatori.',
  },
]

export const modules = [
  {
    title: 'VALUTAZIONE & SVILUPPO DEL GIOCATORE™',
    description:
      'Un sistema professionale per valutare tecnica, tattica, condizione fisica, punti di forza, aree di miglioramento e obiettivi di ogni giocatore, con strumenti pronti per monitorarne l’evoluzione.',
  },
  {
    title: 'LIBRERIA PROFESSIONALE DI ESERCIZI™',
    description:
      'Una raccolta organizzata di esercizi per diritto, rovescio, volée, bandeja, vibora, smash, servizio, risposta, pallonetto, pareti, rete e transizioni, con varianti e progressioni pronte per il campo.',
  },
  {
    title: 'COSTRUZIONE DELLA SESSIONE™',
    description:
      'Strutture professionali per creare lezioni da 45, 60, 75 e 90 minuti, organizzando blocchi di lavoro, obiettivi, esercizi, progressioni e adattamenti per lezioni individuali, coppie e gruppi.',
  },
  {
    title: 'SESSIONI PRONTE ALL’USO™',
    description:
      'Sessioni complete già sviluppate e organizzate per livello e obiettivo, con durata, materiale, esercizi, progressioni, correzioni e applicazioni reali al gioco.',
  },
  {
    title: 'PROGRAMMI DI PROGRESSIONE™',
    description:
      'Programmi strutturati di più settimane per sviluppare tecnica, difesa, attacco, gioco a rete, pareti, transizioni, consistenza e capacità tattica attraverso un percorso progressivo.',
  },
  {
    title: 'COACHING & GESTIONE PROFESSIONALE™',
    description:
      'Schede giocatore, registri delle sessioni, monitoraggio degli obiettivi, report di progresso, pianificazione e strumenti professionali per organizzare il lavoro quotidiano dell’istruttore.',
  },
]

export const bonuses = [
  {
    title: 'TACTICAL MATCH PLAY LAB™',
    description:
      'Un sistema avanzato di situazioni reali di partita per allenare costruzione del punto, conquista della rete, difesa, transizioni, pallonetti, copertura degli spazi, comunicazione della coppia e presa di decisione attraverso esercitazioni pratiche.',
  },
  {
    title: 'PADEL CORRECTION TOOLKIT™',
    description:
      'Una guida professionale per individuare e correggere gli errori più frequenti nei principali colpi e situazioni di gioco, con criteri di osservazione, indicazioni pratiche, esercizi correttivi e progressioni specifiche.',
  },
  {
    title: 'COMPETITION PREPARATION SYSTEM™',
    description:
      'Un sistema completo per preparare giocatori e coppie a partite e tornei con simulazioni, routine pre-match, match plan, scouting, gestione dei punti importanti, checklist operative e valutazione post-partita.',
  },
  {
    title: 'PADEL GROUP CLASS TOOLBOX™',
    description:
      'Strumenti professionali per organizzare lezioni con 4, 6, 8 o più giocatori attraverso stazioni, rotazioni, circuiti, sfide, giochi condizionati e sistemi pratici per mantenere tutti i partecipanti attivi.',
  },
  {
    title: 'PLAYER PROGRESS & REPORTING PACK™',
    description:
      'Una raccolta di schede, registri, valutazioni e report professionali per monitorare tecnica, tattica, obiettivi, progressi e priorità di ogni giocatore durante il percorso di allenamento.',
  },
]

export const benefits = [
  {
    emoji: '⚡',
    title: 'Risparmia Ore Ogni Settimana',
    description:
      'Smetti di creare lezioni, esercizi, progressioni e programmi da zero. Apri il sistema. Scegli il materiale. Personalizzalo se necessario. E prepara settimane di lavoro in pochi minuti.',
  },
  {
    emoji: '👑',
    title: 'Lavora con Maggiore Professionalità',
    description:
      'Organizza il tuo lavoro con un sistema completo composto da esercizi, sessioni, progressioni, programmi, valutazioni e strumenti professionali già pronti. Offri ai tuoi giocatori lezioni più organizzate, efficaci e professionali.',
  },
  {
    emoji: '🤝',
    title: 'Migliora la Qualità delle Tue Lezioni',
    description:
      'Utilizza programmi strutturati, progressioni tecniche e strumenti di monitoraggio che ti permettono di seguire ogni giocatore con maggiore precisione.',
  },
  {
    emoji: '😊',
    title: 'Concentrati Finalmente sui Tuoi Giocatori',
    description:
      'Dedica meno tempo alla preparazione del materiale e più tempo a insegnare, correggere, osservare e sviluppare i tuoi giocatori. È questo il vero lavoro di un istruttore.',
  },
]

export const testimonials = [
  {
    text: 'Insegno padel da nove anni e la domenica sera spariva sempre tra pianificazioni e ricerca di esercizi. Con le Sessioni Pronte all’Uso ho preparato un’intera settimana in venti minuti. I miei gruppi intermedi hanno finalmente una progressione chiara su bandeja e uscite dalla parete.',
    author: 'Alessandro Ferrero, 38',
    role: 'Maestro di padel',
    location: 'Torino',
  },
  {
    text: 'La Libreria di Esercizi vale da sola il prezzo. Ogni esercizio ha obiettivo, varianti e progressione, quindi se il gruppo fatica posso semplificare all’istante invece di improvvisare. Le lezioni collettive scorrono molto meglio e nessuno resta fermo a bordo campo.',
    author: 'Giulia Marchetti, 33',
    role: 'Istruttrice e responsabile scuola padel',
    location: 'Bologna',
  },
  {
    text: 'Seguo due coppie agonistiche e il Competition Preparation System ha cambiato il mio modo di lavorare: match plan, routine pre-partita e valutazione post-match. Entrambe le coppie sono arrivate in finale nel torneo regionale di primavera.',
    author: 'Marco Esposito, 45',
    role: 'Head coach e preparatore di coppie',
    location: 'Napoli',
  },
  {
    text: 'Quello che mi ha convinto sono le schede giocatore e i report di progresso. I miei allievi vedono migliorare consistenza e gioco a rete mese dopo mese, i numeri li motivano e le riconferme a fine stagione sono aumentate parecchio.',
    author: 'Chiara Lombardi, 41',
    role: 'Istruttrice presso circolo sportivo',
    location: 'Milano',
  },
  {
    text: 'Venivo dal tennis e ricostruivo ogni lezione da zero. Con la Costruzione della Sessione ho strutture affidabili da 45, 60 e 90 minuti e con i Programmi di Progressione pianifico otto settimane in una sola serata. Entro in campo molto più sicuro.',
    author: 'Davide Rinaldi, 29',
    role: 'Istruttore di padel',
    location: 'Roma',
  },
]

export const faqs = [
  {
    question: 'È un prodotto fisico o digitale?',
    answer:
      'PADEL MASTER PRO™ è un prodotto digitale in formato PDF ad alta qualità. Potrai scaricarlo immediatamente dopo l’acquisto e utilizzarlo da computer, tablet o smartphone.',
  },
  {
    question: 'È adatto a studenti o principianti?',
    answer:
      'No. Il sistema è stato progettato per istruttori, maestri e allenatori di padel con esperienza, che desiderano risparmiare tempo, organizzare meglio il proprio lavoro e utilizzare materiale professionale già pronto.',
  },
  {
    question: 'Posso adattare il materiale ai miei giocatori?',
    answer:
      'Assolutamente sì. Tutte le sessioni, gli esercizi, i programmi, le valutazioni e gli strumenti possono essere personalizzati in base al livello tecnico, agli obiettivi e alle esigenze di ogni giocatore, coppia o gruppo.',
  },
  {
    question: 'Dopo quanto tempo inizierò a risparmiare tempo?',
    answer:
      'La maggior parte degli istruttori può iniziare già dalla prima settimana a preparare lezioni e programmi molto più velocemente, lavorando con maggiore organizzazione ed efficienza.',
  },
  {
    question: 'Come e quando ricevo l’accesso?',
    answer:
      'Immediatamente dopo il pagamento. Ricevi via email il link di download dei 6 moduli e dei 5 bonus, di solito entro pochi minuti.',
  },
  {
    question: 'È un pagamento unico o un abbonamento?',
    answer:
      'È un pagamento unico di 27€. Ricevi il sistema completo 6-in-1 e tutti i 5 bonus premium, senza costi ricorrenti e senza upsell obbligatori.',
  },
  {
    question: 'Posso stampare esercizi, sessioni e schede?',
    answer:
      'Sì. Sessioni, esercizi, progressioni, valutazioni e schede giocatore sono pronti per la stampa: puoi portarli in campo su una clipboard oppure consultarli da tablet o smartphone.',
  },
  {
    question: 'Funziona per lezioni individuali, coppie e gruppi?',
    answer:
      'Sì. Ogni struttura di sessione include adattamenti per lezioni individuali, coppie e gruppi, e il bonus Padel Group Class Toolbox aggiunge stazioni, rotazioni e circuiti per gruppi numerosi.',
  },
  {
    question: 'Serve materiale o un campo particolare?',
    answer:
      'No. Gli esercizi sono pensati per un campo da padel standard con materiale di base come palline, coni e target, e includono adattamenti per spazi condivisi o tempo di campo limitato.',
  },
  {
    question: 'Cosa succede se non fa per me?',
    answer:
      'Hai 14 giorni per provare tutto il sistema. Se non sei soddisfatto ti basta scriverci entro 14 giorni e ricevi il rimborso completo, senza domande.',
  },
]

export const purchases = [
  { name: 'Alessandro F.', location: 'Torino, Italia' },
  { name: 'Giulia M.', location: 'Bologna, Italia' },
  { name: 'Marco E.', location: 'Napoli, Italia' },
  { name: 'Chiara L.', location: 'Milano, Italia' },
  { name: 'Davide R.', location: 'Roma, Italia' },
  { name: 'Federica S.', location: 'Firenze, Italia' },
  { name: 'Luca B.', location: 'Padova, Italia' },
  { name: 'Simone T.', location: 'Bari, Italia' },
]
